const ALWAYS_EMPTY_OBJECT = Object.freeze({});

const asObject = (value) => (value === null || value === void 1 ? ALWAYS_EMPTY_OBJECT : value);

// noinspection JSUnusedGlobalSymbols
export default asObject;
